
import lottie from 'lottie-web/build/player/lottie_light';
import animationData from '@/assets/lottie/ai-analyzing.json';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendationPopup.components.SizeRecommendationLoadingView',
  name: 'SizeRecommendationLoadingView',
  mounted() {
    this.animation = lottie.loadAnimation({
      container: this.$refs.animation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData
    });
  },
  beforeDestroy() {
    if (this.animation) this.animation.destroy();
  }
};
